import Echo from 'laravel-echo';
// @ts-expect-error no types for socket.io-client
import io from 'socket.io-client';
import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';
import { PUSHER_API_URL } from '~/constants';
import { type Notification, notificationSchema } from './schema';
import { webSocketEventMap } from './config';
import { parseData } from '@devhacker/shared/utils/parseData';

let echo: Echo | null = null;

export function useNotificationService() {
  const { $isDebug, $logger } = useNuxtApp();
  const log = $logger.withScope('🛎️ notification-service');

  function connectPrivateChannel() {
    log('connectPrivateChannel');
    const token = getAccessToken();
    if (!token) return;

    const subId = getSubId(token);
    if (!subId) return;
    log('connectPrivateChannel', { subId, echo });

    if (!echo) {
      log('create new echo');
      const headers = { Authorization: `Bearer ${token}` };
      echo = new Echo({
        broadcaster: 'socket.io',
        client: io,
        host: PUSHER_API_URL,
        auth: { headers },
      });
    }

    echo
      .channel(`pusher_database_private-channel.${subId}`)
      .listen('SocketPrivateEvent', handleWsEvent);
  }

  function leavePrivateChannel() {
    log('leavePrivateChannel', { echo });
    if (!echo) return;

    const token = getAccessToken();
    if (!token) return;

    const subId = getSubId(token);
    if (!subId) return;

    return echo.leaveChannel(`pusher_database_private-channel.${subId}`);
  }

  function handleWsEvent(inputEvent: Notification) {
    const notification = parseData(inputEvent, notificationSchema, $isDebug);
    log('handleWsEvent', notification);
    return;

    const postTitle = notification?.payload?.extends?.postTitle || '';
    const isRecipe = notification?.payload?.extends?.postType === 'recipe';

    if (
      notification.event === 'comment_reply' ||
      notification.event === 'comment_publish' ||
      notification.event === 'comment_rated'
    ) {
      addNotification(notification);
      unviewedNotificationsCount.value += 1;
    }

    if (notification.event === 'comment_reply') {
      const photoUrl = getUserAvatarUrlFromUser(notification?.payload?.extends?.comment?.user);
      const displayName = notification?.payload?.extends?.comment?.user?.display_name;
      const eventText = notification.payload?.extends?.renderTitle;
      const message =
        eventText ||
        `<b>${displayName}</b> ответил(а) вам под ${isRecipe ? 'рецептом' : 'статьёй'} <b>${postTitle}</b>`;

      return showBadge({
        image: photoUrl,
        content: message,
        clickHandler: ({ _id }: Notification) => setReadToNotification(_id),
      });
    }

    if (notification.event === 'comment_publish') {
      const photoUrl = getUserAvatarUrlFromUser(notification.payload.extends.comment.user);
      const displayName = notification.payload.extends.commentUserName;
      const eventText = notification.payload?.extends?.renderTitle;
      const message =
        eventText ||
        `<b>${displayName}</b> оставил(а) комментарий к ${isRecipe ? 'рецепту' : 'статье'} <b>${postTitle}</b>`;

      return showBadge({
        image: photoUrl,
        content: message,
        clickHandler: ({ _id }: Notification) => setReadToNotification(_id),
      });
    }

    if (notification.event === 'comment_rated') {
      const photoUrl = getUserAvatarUrlFromUser(notification.payload.extends.like.user);
      const displayName = notification.payload.extends.like.user.display_name;
      const likeText = isRecipe
        ? webSocketEventMap.comment_rated_like_recipe
        : webSocketEventMap.comment_rated_like;
      const dislikeText = isRecipe
        ? webSocketEventMap.comment_rated_dislike_recipe
        : webSocketEventMap.comment_rated_dislike;
      const text = notification.payload.content === 'like' ? likeText : dislikeText;

      const eventText = notification.payload?.extends?.renderTitle;
      const message = eventText || `<b>${displayName}</b> ${text} <b>${postTitle}</b>`;

      return showBadge({
        image: photoUrl,
        content: message,
        clickHandler: ({ _id }: Notification) => setReadToNotification(_id),
      });
    }

    if (notification.event === 'profile_updated') {
      return showBadge({ content: notification.payload.extends.message });
    }

    if (notification.event === 'kolokolchick_update_meta') {
      return fetchUnviewedNotificationsCount();
    }
  }

  // временно тут
  function getUserAvatarUrlFromUser(_avatar?: string) {
    return 'test';
  }

  return { connectPrivateChannel, leavePrivateChannel };
}
